





























































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { onlyFloat, isDecimal } from '@/utils/common'
import { MensagensDaApiEnum } from '@/types/_'

@Component

export default class ComponentModalCriarEditarTaxaAluguel extends Vue {
  @Prop({ required: true, default: 'CREATE' }) mode: string

  $refs!: { formItemTaxaAluguel: any }

  formItemTaxaAluguelRules: any = {
    valid: true,
    tipo: [(v: string) => !!v || 'Campo obrigatório'],
    valor: [(v: string) => this.validateValor(v)],
  }

  validateValor(value: string) {
    if (isDecimal(value)) return 'Formato inválido.'
    return true
  }

  dicaValor: string = 'Use somente números inteiros ou decimais separados por ponto (.)'

  loadCreateOrUpdateItemTaxaAluguel: boolean = false
  get loadingCreateOrUpdateItemTaxaAluguel() { return this.loadCreateOrUpdateItemTaxaAluguel }
  set loadingCreateOrUpdateItemTaxaAluguel(value: boolean) { this.loadCreateOrUpdateItemTaxaAluguel = value }

  get modalCriarEditarItemTaxaAluguel() { return this.getFinanceiroStore.modal.criarEditarItemTaxaAluguel }
  set modalCriarEditarItemTaxaAluguel(value: boolean) { this.getFinanceiroStore.setModal({ name: 'criarEditarItemTaxaAluguel', value }) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  async createOrUpdateItemTaxaAluguel() {
    this.loadingCreateOrUpdateItemTaxaAluguel = true

    if (this.$refs.formItemTaxaAluguel.validate()) {
      const request = this.mode === 'CREATE'
        ? await this.getFinanceiroStore.createTaxaAluguel()
        : await this.getFinanceiroStore.updateTaxaAluguel()

      if (request.success) {
        if (request.message === MensagensDaApiEnum.UNCHANGED_PAYLOAD && this.mode === 'EDIT') {
          EventBus.$emit('setSnackbar', { show: true, text: 'Nenhuma alteração foi realizada', icon: 'info', color: '#2196F3' })
          this.modalCriarEditarItemTaxaAluguel = false
          this.loadingCreateOrUpdateItemTaxaAluguel = false
          return
        }

        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Item ${this.mode === 'CREATE' ? 'criado' : 'atualizado'} com sucesso! ${String.fromCodePoint(0x1f642)}`,
          icon: 'done',
          color: '#2E7D32',
        })
        this.$emit('update-items-table', true)
        this.modalCriarEditarItemTaxaAluguel = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: request.message ? `${request.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um erro na requisição... ${String.fromCodePoint(0x1f615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingCreateOrUpdateItemTaxaAluguel = false
  }

  onlyFloatUtil(value) {
    return onlyFloat(value)
  }

  @Watch('modalCriarEditarItemTaxaAluguel')
  onChangeModalCriarEditarItemTaxaAluguel(value) {
    if (!value) {
      this.getFinanceiroStore.clearItemTaxaAluguel()
      this.getFinanceiroStore.clearOriginalItemTaxaAluguel()
      this.$refs.formItemTaxaAluguel.resetValidation()
    }
  }
}
